module.exports = __webpack_public_path__ + "img/vino.ec3df480.jpg";